import React, {Component} from 'react';
import {ASSETS_URL} from '../../../constants/endpoints';

import style from '../css/button.css';
import {betSlipAnimationCalculate} from '../../../helpers/helperFunctions';
import device from 'current-device';

export default class Button extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isClicked: false,
            animationSourceRect: {
                top: 0,
                left: 0,
            },
        }
        this.ref = React.createRef();
    }

    _triggerAnimation() {
        if (this.props.isQuickBet) {
            this._videoFramePropertyHandler();
        }
        let sourceRectValues = betSlipAnimationCalculate(this.props.isQuickBet, this.props.reference ? this.props.reference.current : this.ref.current);
        clearTimeout(this.handle);

        this.setState({
            ...this.state,
            isClicked: true,
            animationSourceRect: {
                top: sourceRectValues.sourceTop,
                left: sourceRectValues.sourceLeft,
            }
        })

        this.handle = setTimeout(() => {
            this.setState({
                ...this.state,
                isClicked: false
            })
        }, 1000);
        let isEnabled = this.props.isEnabled;
        let callback = isEnabled ? this.props.callback : null;
        callback();
    }

    _videoFramePropertyHandler() {
        document.documentElement.style.setProperty('--bottomContainerScrollProperty', `visible`);
        if (!(device.mobile() && !device.tablet())) {
            document.documentElement.style.setProperty('--insideContainerOverlayProperty', `visible`);
        }
        setTimeout(() => {
            if (!document.getAnimations().some((e) => e.effect.target.id === 'quick_bet_animation')) {
                document.documentElement.style.setProperty('--bottomContainerScrollProperty', `scroll`);
                if (!(device.mobile() && !device.tablet())) {
                    document.documentElement.style.setProperty('--insideContainerOverlayProperty', `hidden`);
                }
            }
        }, 1100);
    }

    render() {
        let htmlId = this.props.htmlId;
        let label = this.props.sbLabel;
        let mainStyle = this.props.style;
        let isChecked = this.props.isChecked;
        let isEnabled = this.props.isEnabled;
        let isDisabledStyle = !isEnabled ? this.props.complexBet ? style.complexBetDisabled : style.disabled : '';
        let callback = isEnabled ? this.props.callback : null;
        let buttonStyle = this.props.buttonStyle;
        let buttonWrapperStyle = isChecked ? `${style.oddsButtonEnabledstyle} ${this.props.buttonWrapperStyle}` : '';
        let circleSize = this.props.circleSize === undefined ? '' : this.props.circleSize;
        let tickStyle;
        let textStyle = `${style.buttonLabel} ${style.textCapitalize} ${buttonStyle}`;
        let tickBackgroundColor = isEnabled ? `${style.buttonSelectedTickBackgroundColor}` : '';

        if (circleSize === 'small') {
            tickStyle = this.props.isAnimationEnabled ? `${style.tick_small} ${style.tickAnimation}` : `${style.tick_small} `;
        } else if (circleSize === 'medium') {
            tickStyle = this.props.isAnimationEnabled ? `${style.tick_medium} ${style.tickAnimation}` : `${style.tick_medium} `;
        } else if (circleSize === 'large') {
            tickStyle = this.props.isAnimationEnabled ? `${style.tick_large} ${style.tickAnimation}` : `${style.tick_large} `;
        } else {
            tickStyle = this.props.isAnimationEnabled ? `${style.tickAnimation}` : ``;
        }

        let subScriptStyle = isChecked ? `${style.buttonLabel} ${buttonStyle} ${isDisabledStyle} ${style.buttonLabelSub} ${style.checkedButtonSubScript}` : `${style.buttonLabel} ${buttonStyle} ${isDisabledStyle} ${style.buttonLabelSub}`;
        let labelSubScript = this.props.sbSub ? (<span className={subScriptStyle}>{this.props.sbSub}</span>) : '';

        if (isChecked) {
            let sourceRectValues;
            if (this.props.isClicked) {
                this._videoFramePropertyHandler();
                sourceRectValues = betSlipAnimationCalculate(this.props.isQuickBet, this.props.reference ? this.props.reference.current : this.ref.current);
            }
            return (<div className={mainStyle} onClick={callback}
                         ref={this.props.reference ? this.props.reference : this.ref}>
                <div id={htmlId}
                     className={`${style.button} ${isDisabledStyle} ${buttonWrapperStyle} ${tickBackgroundColor}`}>
                    <div className={`${style.tickContainer}`}>
                        <div className={`${style.tick} ${tickStyle}`}></div>
                    </div>
                    <span className={`${textStyle} ${style.checkedButton}`}>{label}</span>
                    {labelSubScript}
                </div>
                {this.state.isClicked && (<div id={(this.props.isQuickBet) ? 'quick_bet_animation' : ''}
                                               className={`${style.betSlipAnimation}`}
                                               style={{
                                                   top: `${this.state.animationSourceRect.top}px`,
                                                   left: `${(this.state.animationSourceRect.left)}px`
                                               }}>
                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`} width="35"
                         height="35"/>
                </div>)}
                {this.props.isClicked && (
                    <div id={'quick_bet_animation'} className={`${style.betSlipAnimation}`}
                         style={{top: `${sourceRectValues.sourceTop}px`, left: `${(sourceRectValues.sourceLeft)}px`}}>
                        <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`} width="35"
                             height="35"/>
                    </div>)}
            </div>);
        } else {
            return (<div className={mainStyle} onClick={
                this.props.complexBet ? callback : ()=> this._triggerAnimation()}
            ref={this.props.reference ? this.props.reference : this.ref}>
                <div id={htmlId} className={`${style.button} ${isDisabledStyle} ${buttonWrapperStyle}`}>
                    <span className={textStyle}>{label}</span>
                    {labelSubScript}
                </div>
            </div>);
        }

    }
}



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/button.js